import { FormattedMessage } from "react-intl";

import styles from "./styles.module.css";

export default function Divider() {
  return (
    <div className={styles.dividerWrapper} role="separator" >
      <span className={styles.line} aria-hidden="true" />
      <span className={styles.text}>
        <FormattedMessage id="common.or" />
      </span>
      <span className={styles.line} aria-hidden="true" />
    </div>
  )
}
